import request from '@/utils/request'
export function getAllMember(data) {
    return request({
        url: `api/serviceCenter/wx-pay/getAllMember?access=${data}`,
        method: 'post',
        data,
    })
}

export function unbinding(data) {
    return request({
        url: `api/serviceCenter/wx-pay/unbinding`,
        method: 'post',
        data,
    })
}